import { apiRequest } from './client.ts';

/**
 * Una fila de la clasificación.
 *
 * `rank` lo calcula el backend SOLO con los cuatro criterios de R14, así que dos
 * usuarios realmente empatados comparten puesto (1, 1, 3). El orden de las filas lleva
 * además un quinto criterio técnico (`user_id`) que existe únicamente para que la tabla
 * no baile entre recargas y que NO tiene significado de producto (D5.1).
 *
 * `tied` marca a quien empata con alguien más en esos cuatro criterios.
 */
export interface StandingEntry {
  rank: number;
  user_id: string;
  username: string;
  role: 'owner' | 'member';
  /** CENTIPUNTOS (×100). Ver src/lib/puntos.ts. */
  points_centi: number;
  exact_hits: number;
  winner_hits: number;
  settled_matches: number;
  reached_total_at: string | null;
  tied: boolean;
  /**
   * Racha VIVA ahora mismo (R5/R19). No es un historial ni un logro conseguido: si el
   * usuario falla o se salta un partido, esto vuelve a 0 y el distintivo desaparece.
   */
  current_streak: number;
}

export interface StandingsResponse {
  league_id: string;
  /**
   * Umbrales de R4, los mismos que activan los multiplicadores de puntos. Vienen del
   * backend (`points_config`) para que no haya un 3 y un 5 escritos a mano por aquí.
   */
  streak_thresholds: number[];
  standings: StandingEntry[];
}

export function getStandings(leagueId: string): Promise<StandingsResponse> {
  return apiRequest(`/leagues/${leagueId}/standings`);
}
